module.exports = __webpack_public_path__ + "static/signature-d2d142e6b68624b3b23a860961981eed.jpg";